module.exports = __webpack_public_path__ + "img/praise3.913b7d12.png";